
import { defineComponent, computed, PropType } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'

const eventUseContents = {
  online: {
    title: 'Webイベントの利用について',
    titleIcon: 'pc-person',
    description:
      'オンラインで効率よくスマートに多くの病院に出会い、情報収集をしていただくための利用サービスの使い方をご紹介。',
    points: [
      {
        heading: 'チャットで直接質問ができる',
        image: require('@/assets/images/events/events-point-01.png'),
        description:
          'LIVE配信セミナーはチャットで直接質問ができます。学生側の顔出しはなし。匿名でも質問ができます。普段聞きにくい質問もこの機会にしてみよう！'
      },
      {
        heading: 'アーカイブ視聴ができる',
        image: require('@/assets/images/events/events-point-02.png'),
        description:
          '予定が合わず、LIVE配信セミナーを見逃してもアーカイブ動画の視聴ができます。アーカイブを視聴してしっかりと情報収集をしよう！'
      },
      {
        heading: 'スマホやタブレットでも<br/>視聴できる',
        image: require('@/assets/images/events/events-point-03.png'),
        description:
          'マイナビのWEBイベントはPC、スマホ、タブレット端末を問わず、どこからでも視聴ができます。'
      },
      {
        heading: '効率よくたくさん<br/>情報収集ができる',
        image: require('@/assets/images/events/events-point-04.png'),
        description:
          'これからの合同説明会は自宅で参加可能。効率よく情報収集ができるのでより多くの比較ができるようになりました。'
      }
    ]
  },
  offline: {
    title: '対面型イベントの利用について',
    titleIcon: 'conversation',
    description:
      '会場で効率よくスマートに多くの病院に出会い、情報収集をしていただくためのご利用案内。',
    points: [
      {
        heading: 'カンタンに<br/>チェックインできる',
        image: require('@/assets/images/events/events-point-05.png'),
        description:
          '会員登録して事前に参加するイベントを予約！イベント当日は入場受付と病院ブースでQRコードを読み取るだけでカンタンにチェックイン（受付）が完了できます。'
      },
      {
        heading: '研修医や病院担当者に<br/>直接質問ができる',
        image: require('@/assets/images/events/events-point-06.png'),
        description:
          '会場で直接質問ができるからこそ、病院で実際に働くイメージや病院の雰囲気、また他の医学生の雰囲気も“生（リアル）の情報”を得ることができます。さらに研修医や病院担当者に顔を覚えてもらえる可能性が高くなるかも。'
      },
      {
        heading: '効率よくたくさん<br/>情報収集ができる',
        image: require('@/assets/images/events/events-point-07.png'),
        description:
          '多数の病院が出展しており効率よく情報収集ができ、多くの比較検討ができます。せっかくの機会なので興味がなかった病院にも伺うことで、より理想とするキャリアを築く病院が見つかるかも。'
      },
      {
        heading: 'しっかりとした<br/>感染症対策の実施',
        image: require('@/assets/images/events/events-point-08.png'),
        description:
          '参加される学生の皆さん、病院関係者などすべての方々の不安を払拭し、有意義なイベントとするための施策を実施しています。ご協力いただき、安心してご来場ください。'
      }
    ]
  }
}

type EventType = 'オンライン' | 'オフライン'
export default defineComponent({
  name: 'EventUse',
  props: {
    eventType: {
      type: String as PropType<EventType>,
      default: 'オンライン'
    }
  },
  components: {
    HeadingLv2
  },

  setup(props) {
    const contents = computed(() => {
      if (props.eventType === 'オフライン') return eventUseContents.offline
      return eventUseContents.online
    })
    const title = computed(() => contents.value.title)
    const titleIcon = computed(() => contents.value.titleIcon)
    const description = computed(() => contents.value.description)
    const points = computed(() => contents.value.points)
    return {
      title,
      titleIcon,
      description,
      points
    }
  }
})
